export const calculatePackagePrice = ({
  selectedPackage,
  packages,
  vatRate = 25
}) => {
  if (!selectedPackage) {
    return {
      packageTotal: 0,
      packageTotalNoVat: 0,
    };
  }
  
  const packageKey = String(selectedPackage);
  const packageDiscounted = packages[packageKey] || 0;

  // With VAT
  const packageTotal = packageDiscounted;

  // Without VAT
  const packageTotalNoVat = packageTotal / (1 + vatRate / 100);

  return {
    packageTotal,
    packageTotalNoVat,
  };
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Package/PackageUtils.js